import { render } from "./WhatsappFlutuante.vue?vue&type=template&id=1e311b37&scoped=true&ts=true"
import script from "./WhatsappFlutuante.vue?vue&type=script&lang=ts"
export * from "./WhatsappFlutuante.vue?vue&type=script&lang=ts"

import "./WhatsappFlutuante.vue?vue&type=style&index=0&id=1e311b37&scoped=true&lang=css"

import exportComponent from "C:\\Users\\leonardo.wolber\\Documents\\GitHub\\LimaTec\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e311b37"]])

export default __exports__